// utils/toastConfirm.js
import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function showConfirmToast(message, options = {}) {
  const {
    confirmText = 'ยืนยัน',
    cancelText = 'กลับ',
    position = 'top-center',
    className = '',
    confirmButtonProps = {},
    cancelButtonProps = {}
  } = options;

  return new Promise((resolve) => {
    const id = toast(
      ({ closeToast }) => (
        <div style={{ minWidth: 260, maxWidth: 460 }}>
          <div style={{ marginBottom: 10 }}>{message}</div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button
              onClick={() => { toast.dismiss(id); resolve(false); }}
              {...cancelButtonProps}
              style={{
                background: '#e0e0e0',
                color: '#111',
                border: 'none',
                padding: '6px 10px',
                borderRadius: 6,
                cursor: 'pointer',
                ...cancelButtonProps.style
              }}
            >
              {cancelText}
            </button>

            <button
              onClick={() => { toast.dismiss(id); resolve(true); }}
              {...confirmButtonProps}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '6px 10px',
                borderRadius: 6,
                cursor: 'pointer',
                ...confirmButtonProps.style
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      ),
      {
        position,
        autoClose: false, // รอผู้ใช้กดยืนยัน/ยกเลิก
        closeOnClick: false,
        draggable: false,
        hideProgressBar: true,
        pauseOnHover: true,
        className
      }
    );
  });
}
